import { IDataGridPageRequest, convertObjectToGetParams, ToastService } from '@siu/shared';
import { IAsociarCasillaSolicitudRequest, IAsociarCasillaTransportistaSolicitudRequest, IGuardarImagenVehiculoAutorizacion } from '../interfaces/autorizacion.interface';
import { Observable, of } from 'rxjs';
import { AUTORIZACIONES } from '../data/autorizacion.data';
import { HttpClient } from "@angular/common/http";
import { Injectable } from '@angular/core';
import { IFormBuscarSolicitudes } from '../pages/autorizacion-aprob-online/store/crud.store.interface';
import { environment } from 'src/environments/environment';
import { map, catchError } from 'rxjs/operators';
import { BaseService } from '@app/core/services/base.service';
import { IRegistrarTramoItinerarioRequest, IActualizarTramoItinerarioRequest, IRegistrarDiagramaRequest, IActualizarDiagramaRequest, IRegistrarRequisitoRequest, IActualizarRequisitoRequest, IEliminarRequisitoxSolicitudTipoRequisitoRequest, IEliminarRequisitoRequest, IRegistrarConductorRequest, IRegistrarVEscoltaRequest, IActualizarVEscoltaRequest, IEliminarCronogramaTramoPorCronogramaRequest, IActualizarCronogramaTramoRequest, IRegistrarCronogramaTramoRequest, IEliminarVEscoltaPorCronogramaRequest, IRegistrarCronogramaRequest, IBuscarCronogramaPorSolicitudRequest, IRegistrarSubsanadoRequest, IRegistrarSubsanadoRequisitoRequest, IActualizarSubsanadoRequisitoRequest, IRegistrarPeticionRevisarRequisitoRequest, IActualizarPeticionRevisarRequisitoRequest, IRegistrarPeticionRevisionSolicitudRequest } from '../pages/formulario-autorizacion-aam/store/formulario-autorizacion-aam.store.interface';

@Injectable()
export class AutorizacionService extends BaseService {
  private url: string = `${environment.apiGatewayAddress}/a/v1/AutorizacionAAM/`;
  private urlApiGateway: string = `${environment.apiGatewayAddress}/api/v1/Autorizacion/`;

  constructor(
    private http: HttpClient,
    toast: ToastService
  ) { 
    super(toast);
  }

  public datasource = AUTORIZACIONES;

  fetchSolicitudes = (
    pageRequest: IDataGridPageRequest,
    value: IFormBuscarSolicitudes  
  ): Observable<any> => 
  {
    const data = { 
      page: pageRequest.page,
      pageSize: pageRequest.pageSize,
      skip: pageRequest.skip,
      sortField: pageRequest.orderBy,
      sortDir: pageRequest.orderDir, 
      filter: value  
    };
    const params = convertObjectToGetParams(data);
    return this.http.get(`${this.url}Buscar-Solicitud`, { params });
  };

  fetchTipoAutorizacion = (): Observable<any> => 
  {
    return this.http.get(`${this.url}Listar-TipoAutorizacion`);
  };

  fetchEstados = (): Observable<any> => 
  {
    const data = [
      {
        pK_eIdSolicitudEstado: 1,
        cSolicitudEstado: "EN PROCESO"
      },
      {
        pK_eIdSolicitudEstado: 2,
        cSolicitudEstado: "OBSERVADO"
      },
      {
        pK_eIdSolicitudEstado: 3,
        cSolicitudEstado: "APROBADO"
      },
      {
        pK_eIdSolicitudEstado: 4,
        cSolicitudEstado: "NO PRESENTADO"
      },
      {
        pK_eIdSolicitudEstado: 5,
        cSolicitudEstado: "ENVIADO"
      },
      {
        pK_eIdSolicitudEstado: 6,
        cSolicitudEstado: "OBSERVADO-SUBSANADO"
      },
      {
        pK_eIdSolicitudEstado: 7,
        cSolicitudEstado: "RECONSIDERACIÓN EN PROCESO"
      },
      {
        pK_eIdSolicitudEstado: 8,
        cSolicitudEstado: "RECHAZADO"
      },
      {
        pK_eIdSolicitudEstado: 12,
        cSolicitudEstado: "APELACIÓN EN PROCESO"
      }
    ];
    let resp = {
      success: true,
      result: data
    }
    return of(resp);
    // return this.http.get(`${this.url}Listar-SolicitudEstado`);
  };

  deleteSolicitud = (idSolicitud: string, idUsuario: string): Observable<any> => {
    const params = {
      pK_eIdSolicitud: idSolicitud,
      eIdUsuarioActualizacion: idUsuario
    };
    return this.http.delete(`${this.url}Eliminar-Solicitud`, {params});
  };

  padZero(num: number, size: number): string {
    let s = num.toString();
    while (s.length < size) {
      s = '0' + s;
    }
    return s;
  }

  descargarAutorizacion = (
    idAutorizacion: number,
    nombreArchivoSinExtension: string,
    idExpSolicitud: number
  ) => 
  {
    //TEO ZAPATA INI - genero el cCodigoAutorizacion ya que no se guarda
    if(nombreArchivoSinExtension==undefined)
    {
      const currentDate = new Date();
      const anioActual = currentDate.getFullYear();
      const mesActual = currentDate.getMonth() + 1; // Los meses en JavaScript van de 0 a 11
      const diaActual = currentDate.getDate();
      const codeAutorizacion = '01';
      const codigoGenerado = codeAutorizacion + 
                           anioActual.toString() + 
                           this.padZero(mesActual, 2) + 
                           this.padZero(diaActual, 2) + 
                           '.' + 
                           this.padZero(idAutorizacion, 5);
      nombreArchivoSinExtension=codigoGenerado;
    }
    //TEO ZAPATA FIN
    const params = convertObjectToGetParams({ idAutorizacion, nombreArchivoSinExtension,idExpSolicitud  });
    this.http.get(`${this.urlApiGateway}descargar-PDF-autorizacion`,{
      params,
      responseType: 'arraybuffer'      
    } 
     )
     .pipe(
      map(response => {
        return response;
      }),
      catchError(this.handleErrorResponse)
    ).subscribe(
      (response) => {
        console.log('Archivo', response);
      this.downloadFile(response, "application/octet-stream", nombreArchivoSinExtension + '.pdf')
      },
      () => {
        this.toast.error('No se encontró el archivo')
      });
  };

  exportarAutorizacionExt = (
    pageRequest: IDataGridPageRequest,
    value: IFormBuscarSolicitudes    
  ) => 
  {
    const data = { 
      page: pageRequest.page,
      pageSize: pageRequest.pageSize,
      skip: pageRequest.skip,
      sortField: pageRequest.orderBy,
      sortDir: pageRequest.orderDir, 
      filter: value  
    }; 
    const params = convertObjectToGetParams(data);
    this.http.get(`${this.url}ExportarAutorizacionExt`, { params, responseType: 'blob' })
    .pipe(
      map(response => {
        return response;
      }),
      catchError(this.handleErrorResponse)
    )
    .subscribe(
      (response) => {
        console.log('Excel', response);
        this.downLoadFile(response, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", 'Listado de Autorizaciones.xlsx')
      },
      (error) => {
        console.error(error);
        this.toast.error('Ocurrió un error durante la transacción. Comuníquese con el Administrador del Sistema.')
      });
  };

  insertarTramosItinerario = (
    request: IRegistrarTramoItinerarioRequest
  ) : Observable<any> => 
  {

    return this.http.post(`${this.url}Insertar-Tramos-Itinerario`, request);
  }

  actualizarTramosItinerario = (
    request: IActualizarTramoItinerarioRequest
  ): Observable<any> => 
  {
    return this.http.put(`${this.url}Actualizar-Tramos-Itinerario`, request);
  }

  listarTiposVehiculoPorConfiguracionVehicular = (
    idConfiguracionVehicular: number
  ) => 
  {
    return this.http.get(`${this.url}Listar-TipoVehiculo-PorConfVehicular?idConfiguracionVehicular=${idConfiguracionVehicular}`)
  }

  descargarCargoSolicitudAutorizacion = (
    idAutorizacion: number,
    nombreArchivoSinExtension: string  ) => 
  {
    return new Promise<any>((resolve, reject) => {
      const params = convertObjectToGetParams({ idAutorizacion, nombreArchivoSinExtension  });
      this.http.get(`${this.urlApiGateway}descargar-PDF-cargo-autorizacion`,{
        params,
        responseType: 'arraybuffer'
      } 
      )
      .pipe(
          map(response => {
            return response;
          }),
          catchError(this.handleErrorResponse)
        )
      .subscribe(
        (response) => 
        {
          console.log('Archivo', response);
          this.downLoadFile(response, "application/octet-stream", nombreArchivoSinExtension + '.pdf');
          resolve(true);
        },
        (error) => 
        {
          alert('No se encontró el archivo.');
          reject(error);
        });
    });    
  }

  descargarCargoSolicitudActualizarCronograma = (
    idAutorizacion: number,
    idCronograma: number,
    nombreArchivoSinExtension: string  ) => 
  {
    return new Promise<any>((resolve, reject) => {
      const params = convertObjectToGetParams({ idAutorizacion, idCronograma, nombreArchivoSinExtension  });
      this.http.get(`${this.urlApiGateway}descargar-PDF-cargo-cronograma`,{
        params,
        responseType: 'arraybuffer'
      } 
      )
      .pipe(
          map(response => {
            return response;
          }),
          catchError(this.handleErrorResponse)
        )
      .subscribe(
        (response) => 
        {
          console.log('Archivo', response);
          this.downLoadFile(response, "application/octet-stream", nombreArchivoSinExtension + '.pdf');
          resolve(true);
        },
        (error) => 
        {
          alert('No se encontró el archivo.');
          reject(error);
        });
    });    
  }

  descargarCargoSolicitudSubsanarRequisito = (
    idAutorizacion: number,
    idSubsanado: number,
    nombreArchivoSinExtension: string  ) => 
  {
    return new Promise<any>((resolve, reject) => {
      const params = convertObjectToGetParams({ idAutorizacion, idSubsanado, nombreArchivoSinExtension  });
      this.http.get(`${this.urlApiGateway}descargar-PDF-cargo-subsanado`,{
        params,
        responseType: 'arraybuffer'
      } 
      )
      .pipe(
          map(response => {
            return response;
          }),
          catchError(this.handleErrorResponse)
        )
      .subscribe(
        (response) => 
        {
          console.log('Archivo', response);
          this.downLoadFile(response, "application/octet-stream", nombreArchivoSinExtension + '.pdf');
          resolve(true);
        },
        (error) => 
        {
          alert('No se encontró el archivo.');
          reject(error);
        });
    });    
  }

  descargarSubsanadoRequisito = (
    idAutorizacion: number,
    idSubsanadoRequisito: number,
    nombreArchivoSinExtension: string  ) => 
  {
    return new Promise<any>((resolve, reject) => {
      const params = convertObjectToGetParams({ idAutorizacion, idSubsanadoRequisito, nombreArchivoSinExtension  });
      this.http.get(`${this.urlApiGateway}descargar-subsanado-requisito`,{
        params,
        responseType: 'arraybuffer'
      } 
      )
      .pipe(
          map(response => {
            return response;
          }),
          catchError(this.handleErrorResponse)
        )
      .subscribe(
        (response) => 
        {
          console.log('Archivo', response);
          this.downLoadFile(response, "application/octet-stream", nombreArchivoSinExtension + '.pdf');
          resolve(true);
        },
        (error) => 
        {
          alert('No se encontró el archivo.');
          reject(error);
        });
    });    
  }

  listarTramosPorItinerario = (
    idItinerario: number
  ) => 
  {
    return this.http.get(`${this.url}Consultar-TramoPorIdItinerario?idItinerario=${idItinerario}`)
  }

  buscarDiagramaPorId = (
    idDiagrama: number
  ) : Observable<any> => 
  {
    return this.http.get(`${this.url}Buscar-Diagrama-PorId?idDiagrama=${idDiagrama}`)
  }

  registrarDiagrama = (
    request: IRegistrarDiagramaRequest
  ) : Observable<any> => 
  {
    return this.http.post(`${this.url}Registrar-Diagrama`, request);
  }

  actualizarDiagrama = (
    request: IActualizarDiagramaRequest
  ): Observable<any> => 
  {
    return this.http.put(`${this.url}Actualizar-Diagrama`, request);
  }

  registrarDiagramaConArchivo = (
    request: IRegistrarDiagramaRequest,
    archivo
  ) : Observable<any> => 
  {
    let form = new FormData();
    form.append('Diagrama', JSON.stringify(request));
    form.append('ArchivoDiagrama', archivo);
    form.append('eIdUsuarioRegistro', request.eIdUsuarioRegistro.toString());

    return this.http.post(`${this.urlApiGateway}Registrar-Diagrama`, form);
  }

  actualizarDiagramaConArchivo = (
    request: IActualizarDiagramaRequest,
    archivo
  ): Observable<any> => 
  {
    let form = new FormData();
    form.append('Diagrama', JSON.stringify(request));
    form.append('ArchivoDiagrama', archivo);
    form.append('eIdUsuarioActualizacion', request.eIdUsuarioActualizacion.toString());

    return this.http.put(`${this.urlApiGateway}Actualizar-Diagrama`, form);
  }

  guardarImagenVehiculoAutorizacion = (datosAutorizacionPDF: IGuardarImagenVehiculoAutorizacion) : Observable<any> => {
    
    let form = new FormData();
    form.append('idAutorizacion', datosAutorizacionPDF.idAutorizacion.toString());
    form.append('ArchivoImagenVehivulo', datosAutorizacionPDF.archivoImagenVehivulo);
    
    return this.http.post(`${this.urlApiGateway}guardar-imagen-vehiculo-autorizacion`, form)
    .pipe(
      map(resp=>{
        return resp;
      }),
      catchError(this.handleErrorResponse)
    )
  };

  asociarCasillaSolicitud = (
    request: IAsociarCasillaSolicitudRequest
  ) : Observable<any> => 
  {
    return this.http.post(`${this.url}Asociar-Casilla-Solicitud`, request);
  }

  asociarCasillaTransportistaSolicitud = (
    request: IAsociarCasillaTransportistaSolicitudRequest
  ) : Observable<any> => 
  {
    return this.http.post(`${this.url}Asociar-Casilla-Transportista-Solicitud`, request);
  }

  private downLoadFile(data: any, type: string, fileName: string) {
    let blob = new Blob([data], { type: type});
    let url = window.URL.createObjectURL(blob);
    
    var downloadLink = document.createElement("a");
    downloadLink.href = url;
    downloadLink.download = fileName;

    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  } 

  registrarRequisito = (
    request: IRegistrarRequisitoRequest,
    archivo
  ) : Observable<any> => 
  {
    let form = new FormData();
    form.append('Requisito', JSON.stringify(request));
    form.append('ArchivoRequisito', archivo);

    return this.http.post(`${this.urlApiGateway}Registrar-Requisito`, form);
  }

  actualizarRequisito = (
    request: IActualizarRequisitoRequest,
    archivo
  ) : Observable<any> => 
  {
    let form = new FormData();
    form.append('Requisito', JSON.stringify(request));
    form.append('ArchivoRequisito', archivo);

    return this.http.put(`${this.urlApiGateway}Actualizar-Requisito`, form);
  }

  deleteRequisito = (request: IEliminarRequisitoRequest): Observable<any> => {
    const params = {
      PK_eIdRequisito: request.PK_eIdRequisito.toString(),
      eIdUsuarioActualizacion: request.eIdUsuarioActualizacion.toString()
    };
    return this.http.delete(`${this.url}Eliminar-Requisito`, {params});
  };

  deleteRequisitoByIdSolicitudIdTipoRequisito = (request: IEliminarRequisitoxSolicitudTipoRequisitoRequest): Observable<any> => {
    const params = {
      FK_eIdSolicitud: request.FK_eIdSolicitud.toString(),
      FK_eIdTipoRequisito: request.FK_eIdTipoRequisito.toString(),
      eIdUsuarioActualizacion: request.eIdUsuarioActualizacion.toString()
    };
    return this.http.delete(`${this.url}Eliminar-Requisito-PorIdSolicitudIdTipoRequisito`, {params});
  };

  registrarCronograma = (
    request: IRegistrarCronogramaRequest
  ) : Observable<any> => 
  {
    return this.http.post(`${this.url}Insertar-Cronograma`, request);
  }

  fetchCronogramaByIdSolicitud = (
    request: IBuscarCronogramaPorSolicitudRequest
  ) : Observable<any> => 
  {
    const params = {
      idSolicitud: request.FK_eIdSolicitud.toString(),
      idTipo: request.eIdTipo.toString()
    };
    return this.http.get(`${this.url}Consultar-Cronograma-PorIdSolicitud`, {params})
  }

  registrarConductor = (
    request: IRegistrarConductorRequest
  ) : Observable<any> => 
  {
    return this.http.post(`${this.url}Insertar-Conductor`, request);
  }

  registrarVEscolta = (
    request: IRegistrarVEscoltaRequest
  ) : Observable<any> => 
  {
    return this.http.post(`${this.url}Insertar-VehiculoEscolta`, request);
  }

  actualizarVEscolta = (
    request: IActualizarVEscoltaRequest
  ): Observable<any> => 
  {
    return this.http.put(`${this.url}Actualizar-VehiculoEscolta`, request);
  }

  deleteVEscoltaPorCronograma = (request: IEliminarVEscoltaPorCronogramaRequest): Observable<any> => {
    const params = {
      FK_eIdCronograma: request.FK_eIdCronograma.toString(),
      eIdUsuarioActualizacion: request.eIdUsuarioActualizacion.toString()
    };
    return this.http.delete(`${this.url}Eliminar-VehiculoEscolta-PorIdCronograma`, {params});
  };

  registrarCronogramaTramo = (
    request: IRegistrarCronogramaTramoRequest
  ) : Observable<any> => 
  {
    return this.http.post(`${this.url}Insertar-CronogramaTramo`, request);
  }

  actualizarCronogramaTramo = (
    request: IActualizarCronogramaTramoRequest
  ): Observable<any> => 
  {
    return this.http.put(`${this.url}Actualizar-CronogramaTramo`, request);
  }

  deleteCronogramaTramoPorCronograma = (request: IEliminarCronogramaTramoPorCronogramaRequest): Observable<any> => {
    const params = {
      FK_eIdCronograma: request.FK_eIdCronograma.toString(),
      eIdUsuarioActualizacion: request.eIdUsuarioActualizacion.toString()
    };
    return this.http.delete(`${this.url}Eliminar-CronogramaTramo-PorIdCronograma`, {params});
  };

  fetchObservadoRequisitoByIdExpediente = (
    idExpediente: number
  ) : Observable<any> => 
  {
    const params = {
      idExpediente: idExpediente.toString()
    };
    return this.http.get(`${this.url}Consultar-Observado-Requisito-PorIdExpediente`, {params})
  }

  registrarSubsanado = (
    request: IRegistrarSubsanadoRequest
  ) : Observable<any> => 
  {
    return this.http.post(`${this.url}Insertar-Subsanado`, request);
  }

  registrarSubsanadoRequisito = (
    request: IRegistrarSubsanadoRequisitoRequest,
    archivo
  ) : Observable<any> => 
  {
    let form = new FormData();
    form.append('Requisito', JSON.stringify(request));
    form.append('ArchivoRequisito', archivo);

    return this.http.post(`${this.urlApiGateway}Registrar-Subsanado-Requisito`, form);
  }

  actualizarSubsanadoRequisito = (
    request: IActualizarSubsanadoRequisitoRequest,
    archivo
  ): Observable<any> => 
  {
    let form = new FormData();
    form.append('Requisito', JSON.stringify(request));
    form.append('ArchivoRequisito', archivo);

    return this.http.put(`${this.urlApiGateway}Actualizar-Subsanado-Requisito`, form);
  }

  //#region Petición de Revisión
  registrarPeticionRevision = (
    request: IRegistrarPeticionRevisionSolicitudRequest
  ) : Observable<any> => 
  {
    return this.http.post(`${this.url}Insertar-Peticion-Revision-Solicitud`, request);
  }

  registrarPeticionRevisionRequisito = (
    request: IRegistrarPeticionRevisarRequisitoRequest,
    archivo
  ) : Observable<any> => 
  {
    let form = new FormData();
    form.append('Requisito', JSON.stringify(request));
    form.append('ArchivoRequisito', archivo);

    return this.http.post(`${this.urlApiGateway}Registrar-Peticion-Revision-Requisito`, form);
  }

  actualizarPeticionRevisionRequisito = (
    request: IActualizarPeticionRevisarRequisitoRequest,
    archivo
  ): Observable<any> => 
  {
    let form = new FormData();
    form.append('Requisito', JSON.stringify(request));
    form.append('ArchivoRequisito', archivo);

    return this.http.put(`${this.urlApiGateway}Actualizar-Peticion-Revision-Requisito`, form);
  }

  descargarPeticionRevisionRequisito = (
    idAutorizacion: number,
    idPeticionRequisito: number,
    nombreArchivoSinExtension: string  ) => 
  {
    return new Promise<any>((resolve, reject) => {
      const params = convertObjectToGetParams({ idAutorizacion, idSubsanadoRequisito: idPeticionRequisito, nombreArchivoSinExtension  });
      this.http.get(`${this.urlApiGateway}Descargar-Archivo-Peticion-Revision-Requisito`,{
        params,
        responseType: 'arraybuffer'
      } 
      )
      .pipe(
          map(response => {
            return response;
          }),
          catchError(this.handleErrorResponse)
        )
      .subscribe(
        (response) => 
        {
          this.downLoadFile(response, "application/octet-stream", nombreArchivoSinExtension + '.pdf');
          resolve(true);
        },
        (error) => 
        {
          alert('No se encontró el archivo.');
          reject(error);
        });
    });    
  }
  //#endregion
}
